// Libraries
import React from 'react'
import I18n from 'i18next'
import moment from 'moment'
import { Tooltip, Tag, Icon, Dropdown, Menu } from 'antd'
import { isNil, map, get, defaultTo } from 'lodash'

// Helpers
import { filterPeriod, filterBool } from 'Components/TableLayout/Helpers'
import { getPermitActionsRights } from 'Services/permitsActionsRights'
import ButtonDownload from '../Components/buttons/ButtonDownload'
import ButtonSign from '../Components/buttons/ButtonSign'
import ButtonCapacityControl from '../Components/buttons/ButtonCapacityControl'
import ButtonControl from '../Components/buttons/ButtonControl'
import ButtonCancel from '../Components/buttons/ButtonCancel'
import ButtonClose from '../Components/buttons/ButtonClose'
import ButtonValidateControl from '../Components/buttons/ButtonValidateControl'
import ButtonConfirm from '../Components/buttons/ButtonConfirm'
import ButtonDuplicate from '../Components/buttons/ButtonDuplicate'
import ButtonDelete from '../Components/buttons/ButtonDelete'

const specs = {
  // Nom des Ã©lÃ©ments affichÃ©s et listÃ©s
  element: {
    name: 'permit',
    kind: 'male'
  },

  // Liste des boutons du tableau
  actions: {},

  // Gestion de l'internationalisation
  locale: {
    emptyText: 'pages.permits.table.empty'
  },

  // Affichage du titre
  titleEnabled: true,

  // Affichage de la zone de recherche
  searchEnabled: false,

  // Render custom des en-tÃªtes
  renderHeaderLeft: null,
  renderHeaderRight: null,

  // Gestion de la pagination
  pagination: {
    position: 'both',
    showSizeChanger: true,
    pageSizeOptions: ['10', '25', '50', '100']
  },

  // Identifiant unique de chaque ligne du tableau
  rowKey: 'id',

  // Colonnes du tableau
  columns: {}, // overrided after
  getColumns: ({
    profile,
    constructorFunctions,
    isDownloading,
    loading,
    type,
    onActionDropDownOpen
  }) => ({
    status: {
      title: 'pages.permits.fields.status.title',
      dataIndex: 'status',
      key: 'status',
      render: (status, { dateStatusModified }) => {
        const associatedColors = {
          waiting: '',
          cancelled: 'red',
          closed: 'blue',
          finished: 'orange',
          opened: 'green'
        }

        return !isNil(status) ? (
          <Tooltip
            title={I18n.t(
              `pages.permits.fields.status.options.${status}.tooltip`,
              {
                date:
                  !isNil(dateStatusModified) &&
                  moment(dateStatusModified).isValid()
                    ? moment(dateStatusModified).format('L')
                    : I18n.t('common.unknown.female')
              }
            )}
          >
            <Tag
              className='permit-status'
              color={get(associatedColors, status)}
            >
              {status === 'finished' && <Icon type='warning' />}
              {/* {status === 'waiting' && <Icon type='loading' />} */}
              {I18n.t(`pages.permits.fields.status.options.${status}.title`)}
            </Tag>
          </Tooltip>
        ) : (
          I18n.t('common.unknown.male')
        )
      },
      sorter: true,
      filters: map(
        ['waiting', 'opened', 'finished', 'cancelled', 'closed'],
        status => ({
          text: (
            <Tooltip
              placement='right'
              title={I18n.t(
                `pages.permits.fields.status.options.${status}.tooltip`
              )}
            >
              {I18n.t(
                `pages.permits.fields.status.options.${status}.filterTitle`
              )}
            </Tooltip>
          ),
          value: status
        })
      )
    },
    company: {
      title: 'pages.permits.fields.companyName.title',
      dataIndex: 'company',
      key: 'company',
      render: company =>
        !isNil(company) ? company.name : I18n.t('common.unknown.female'),
      sorter: true
    },
    permitID: {
      title: 'pages.permits.fields.permitID.title',
      dataIndex: 'permitID',
      key: 'permitID',
      render: permitID =>
        !isNil(permitID) ? permitID : I18n.t('common.unknown.male'),
      sorter: true
    },
    validityPeriod: {
      title: 'pages.permits.fields.validityDate.title',
      dataIndex: 'validityPeriod',
      key: 'validityPeriod',
      render: validityPeriod =>
        !isNil(validityPeriod) ? (
          <span className='period'>
            <span className='period-date'>
              {moment(get(validityPeriod, 'startDate')).format('L')}
            </span>
          </span>
        ) : (
          I18n.t('common.unknown.female')
        ),
      // sorter: true,
      ...filterPeriod(null, moment(), [
        'validityPeriod.startDate',
        'validityPeriod.endDate'
      ])
    },
    isSigned: {
      title: 'pages.permits.fields.isSigned.title',
      dataIndex: 'isSigned',
      key: 'isSigned',
      render: isSigned => (
        <Tag color={isSigned ? 'green' : 'volcano'}>
          {I18n.t(`common.${defaultTo(isSigned, false) ? 'yes' : 'no'}`)}
        </Tag>
      ),
      sorter: true,
      ...filterBool('isSigned')
    },
    dateCreated: {
      title: 'pages.permits.fields.dateCreated.title',
      dataIndex: 'dateCreated',
      key: 'dateCreated',
      render: dateCreated =>
        !isNil(dateCreated) ? (
          <Tooltip title={moment(dateCreated).format('L')}>
            {moment(dateCreated).calendar()}
          </Tooltip>
        ) : (
          I18n.t('common.unknown.female')
        ),
      sorter: true,
      ...filterPeriod(null, moment(), 'dateCreated')
    },
    actions: {
      dataIndex: 'status',
      key: 'actions',
      render: (status, record) => {
        const permit = record

        const rights = getPermitActionsRights({
          profile,
          permit,
          type
        })

        const {
          notReader,
          canBeSigned,
          canBeEdited,
          canBeCancelled,
          canBeClosed,
          canValidateControl,
          canAskConfirmRequest,
          canDuplicate,
          canDelete
        } = getPermitActionsRights({
          profile,
          permit,
          type
        })

        const menu = (
          <Menu>
            <Menu.Item key='download'>
              <ButtonDownload
                withinDropdown
                type={type}
                permit={permit}
                isDownloading={isDownloading}
                constructorFunctions={constructorFunctions}
              />
            </Menu.Item>
            {notReader && canBeSigned && (
              <Menu.Item key='sign'>
                <ButtonSign
                  withinDropdown
                  type={type}
                  constructorFunctions={constructorFunctions}
                />
              </Menu.Item>
            )}

            {notReader && canBeEdited.capacityPermit && (
              <Menu.Item key='edit-capacity'>
                <ButtonCapacityControl
                  withinDropdown
                  constructorFunctions={constructorFunctions}
                />
              </Menu.Item>
            )}
            {notReader && canBeEdited.cleaningPermit && (
              <Menu.Item key='edit-control'>
                <ButtonControl
                  withinDropdown
                  constructorFunctions={constructorFunctions}
                />
              </Menu.Item>
            )}
            {notReader && canBeCancelled && (
              <Menu.Item key='cancel'>
                <ButtonCancel
                  withinDropdown
                  constructorFunctions={constructorFunctions}
                />
              </Menu.Item>
            )}
            {notReader && canBeClosed && (
              <Menu.Item key='close'>
                <ButtonClose
                  withinDropdown
                  type={type}
                  constructorFunctions={constructorFunctions}
                />
              </Menu.Item>
            )}
            {notReader && !canBeClosed && canValidateControl && (
              <Menu.Item key='validateControl'>
                <ButtonValidateControl
                  withinDropdown
                  type={type}
                  constructorFunctions={constructorFunctions}
                />
              </Menu.Item>
            )}
            {notReader && canAskConfirmRequest && (
              <Menu.Item key='confirmRequest'>
                <ButtonConfirm
                  withinDropdown
                  constructorFunctions={constructorFunctions}
                />
              </Menu.Item>
            )}
            {notReader && canDuplicate && (
              <Menu.Item key='duplicate'>
                <ButtonDuplicate
                  withinDropdown
                  type={type}
                  constructorFunctions={constructorFunctions}
                />
              </Menu.Item>
            )}
            {canDelete && (
              <Menu.Item key='delete'>
                <ButtonDelete
                  withinDropdown
                  type={type}
                  constructorFunctions={constructorFunctions}
                />
              </Menu.Item>
            )}
            
          </Menu>
        )

        return (
          <Dropdown overlay={menu} trigger={['click']}>
            <button
              onClick={e => {
                e.stopPropagation()
                onActionDropDownOpen(permit)
              }}
              className='action-button-container-no-style'
            >
              {loading ? <Icon type='loading' /> : <Icon type='ellipsis' />}
            </button>
          </Dropdown>
        )
      }
    }
  })
}

export default specs
